'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTiles = exports.getSpeakToSpecialistHoverTitle = exports.getCompareHoverTitle = exports.getDisclaimer = exports.getSecondaryButtonTitle = exports.getSecondaryButtonDTM = exports.getSecondaryButtonURL = exports.getSecondaryButtonText = exports.getPrimaryButtonKey = exports.getPrimaryButtonTitle = exports.getPrimaryButtonDTM = exports.getPrimaryButtonURL = exports.getPrimaryButtonText = exports.getPhoneNumberLabel = exports.getPhoneNumber = exports.getHeaderDescriptionText = exports.getTitleComponentHeaderText = exports.getBackgroundImgUrl = exports.getBackground = exports.getCardShortName = exports.getQeId = exports.getHasReinforcementBanner = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReinforcementBannerDataFromGlobalHeader = function getReinforcementBannerDataFromGlobalHeader(state) {
  return (0, _lodash2.default)(state.intlPage, 'global.globalHeader.reinforcementBanner');
};
var getReinforcementBannerDataFromCardData = (0, _reselect.createSelector)(_common.getCardData, function (card) {
  return (0, _lodash2.default)(card, 'reinforcementBanner');
});
var getReinforcementBannerDataFromPage = function getReinforcementBannerDataFromPage(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.reinforcementBanner');
};

var getReinforcementBannerData = (0, _reselect.createSelector)([getReinforcementBannerDataFromGlobalHeader, getReinforcementBannerDataFromCardData, getReinforcementBannerDataFromPage], function (fromGlobal, fromCard, fromPage) {
  return fromGlobal || fromCard || fromPage;
});

var getHasReinforcementBanner = exports.getHasReinforcementBanner = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return !!reinforementBannerData;
});

var getQeId = exports.getQeId = (0, _reselect.createSelector)([getHasReinforcementBanner, getReinforcementBannerData], function (hasReinforcementData, reinforcementData) {
  return hasReinforcementData ? reinforcementData.qeId : undefined;
});

var getCardShortName = exports.getCardShortName = (0, _reselect.createSelector)(_common.getCardData, function (card) {
  return (0, _lodash2.default)(card, 'shortName') || '';
});
var getBackground = exports.getBackground = (0, _common.getAssetSelector)(function (state) {
  return (0, _lodash2.default)(state.intlPage, 'page.hero.assets') || [];
}, 'background');
var heroAssetsSelector = function heroAssetsSelector(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.hero.assets') || [];
};
var getBackgroundImgUrl = exports.getBackgroundImgUrl = (0, _common.getAssetSelector)(heroAssetsSelector, 'background');
var getTitleComponentHeaderText = exports.getTitleComponentHeaderText = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'content[0].header');
});

var getHeaderDescriptionText = exports.getHeaderDescriptionText = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'content[0].desc') || [];
});

var getPhoneNumber = exports.getPhoneNumber = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'content[1].header') || '';
});

var getPhoneNumberLabel = exports.getPhoneNumberLabel = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'content[1].desc') || [];
});

var getPrimaryButtonText = exports.getPrimaryButtonText = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[0].title') || '';
});

var getPrimaryButtonURL = exports.getPrimaryButtonURL = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[0]') || {};
});

var getPrimaryButtonDTM = exports.getPrimaryButtonDTM = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[0].dtm') || {};
});

var getPrimaryButtonTitle = exports.getPrimaryButtonTitle = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[0].hoverText') || '';
});

var getPrimaryButtonKey = exports.getPrimaryButtonKey = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[0].key') || '';
});

var getSecondaryButtonText = exports.getSecondaryButtonText = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[1].title') || '';
});

var getSecondaryButtonURL = exports.getSecondaryButtonURL = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[1]') || {};
});

var getSecondaryButtonDTM = exports.getSecondaryButtonDTM = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[1].dtm') || {};
});

var getSecondaryButtonTitle = exports.getSecondaryButtonTitle = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'links[1].hoverText') || '';
});

var getDisclaimer = exports.getDisclaimer = (0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
  return (0, _lodash2.default)(reinforementBannerData, 'disclaimer') || {};
});

var getCompareHoverTitle = exports.getCompareHoverTitle = (0, _common.getLabelSelector)('compareCardsHoverTitle');
var getSpeakToSpecialistHoverTitle = exports.getSpeakToSpecialistHoverTitle = (0, _common.getLabelSelector)('speakToSpecialistHoverTitle');

var reinforcementAssetsSelector = function reinforcementAssetsSelector(type) {
  return (0, _common.getAssetsSelector)((0, _reselect.createSelector)(getReinforcementBannerData, function (reinforementBannerData) {
    return (0, _lodash2.default)(reinforementBannerData, 'assets') || [];
  }), type);
};

var getTiles = exports.getTiles = (0, _reselect.createSelector)(reinforcementAssetsSelector('tile'), function (tiles) {
  return Array.isArray(tiles) && tiles.map(function (_ref) {
    var url = _ref.url,
        _ref$alt = _ref.alt,
        alt = _ref$alt === undefined ? '' : _ref$alt;
    return { src: url, alt: alt };
  });
});